import PropTypes from "prop-types";
import React from "react";

const DummyField = props =>
  (<div className={`input-field-wrapper ${props.containerClassName}`}>
    <div className="md-text-field-container md-full-width md-text-field-container--input">
      <label className="md-floating-label">
        {props.hintText}
      </label>
      <div className="md-text-field md-full-width md-text" style={{marginTop: "8px", paddingTop: "20px"}}>
        {props.label}
      </div>
      <hr className="md-divider md-divider--text-field md-divider--expand-from-left"/>
    </div>
  </div>);

DummyField.propTypes = {
  containerClassName: PropTypes.string,
  label: PropTypes.string.isRequired,
  hintText: PropTypes.string.isRequired
};
export default DummyField;